import { QueryClient } from '@tanstack/react-query';
import { isApiError } from './apiError';

/**
 * Configuracion unica del estado de servidor.
 *
 * No se reintenta un 4xx: si el servidor dice que falta un permiso o que el
 * dato no existe, repetir la peticion no cambia la respuesta y solo suma ruido.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (isApiError(error) && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
